const MAX_SIZE_BYTES = 32 * 1024;
const PRIVATE_KEY_EXTENSIONS = [".p12", ".pfx"];

export type CertificateFileError = "private_key" | "too_large" | "missing";

export function validateCertificateFile(
  file: File,
): CertificateFileError | null {
  const name = file.name.toLowerCase();

  if (PRIVATE_KEY_EXTENSIONS.some((extension) => name.endsWith(extension))) {
    return "private_key";
  }
  if (file.size > MAX_SIZE_BYTES) {
    return "too_large";
  }

  return null;
}

export async function readFileAsBase64(file: File): Promise<string> {
  const bytes = new Uint8Array(await file.arrayBuffer());
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }

  return btoa(binary);
}
